import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";
export default function Home() {

  /* ================= HERO SLIDER ================= */
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  

  // Fetch hero images
  useEffect(() => {
    fetch(`${BASE_URL}/api/gethero.php`)
      .then(res => res.json())
      .then(data => {
        console.log("Hero Data:", data);
        setSlides(Array.isArray(data) ? data : []);
      })
      .catch(err => console.error(err));
  }, []);

  // Auto slide (ONLY ONE interval)
  useEffect(() => {
    if (slides.length === 0) return;

    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides]);

  // Reset index when slides change
  useEffect(() => {
    setCurrent(0);
  }, [slides]);


  /* ================= HOLIDAYS ================= */
  const [holidays, setHolidays] = useState([]);

  useEffect(() => {
    const fetchHolidays = () => {
     fetch(`${BASE_URL}/api/getHolidays.php?t=${Date.now()}`)
        .then(res => res.json())
        .then(data => setHolidays(Array.isArray(data) ? data : []))
        .catch(err => console.error(err));
    };

    fetchHolidays();
    const interval = setInterval(fetchHolidays, 5000);

    return () => clearInterval(interval);
  }, []);


  /* ================= NEWS ================= */
  const [newsList, setNewsList] = useState([]);

  useEffect(() => {
    const fetchNews = () => {
      fetch(`${BASE_URL}/api/getNews.php?t=${Date.now()}`)
        .then(res => res.json())
        .then(data => setNewsList(Array.isArray(data) ? data : []))
        .catch(err => console.error(err));
    };

    fetchNews();
    const interval = setInterval(fetchNews, 5000);

    return () => clearInterval(interval);
  }, []);


  /* ================= UI STATE ================= */
  const [activePlan, setActivePlan] = useState("bachat");


  /* ================= RETURN ================= */
  return (
    <>
      
      {/* HERO */}
      <div
        className="hero"
        style={{
          backgroundImage:
            slides.length > 0 && slides[current]
              ? `url(${BASE_URL}/uploads/${slides[current].image})`
              : "none",
        }}
      ></div>


      {/* WELCOME */}
      <div className="welcome-section">
        <div className="welcome-container">
          <h2> શ્રી ધનલક્ષ્મી મહિલા કો-ઓપ. ક્રેડિટ સોસાયટી મા તમારું સ્વાગત છે</h2>
          <p>
            સમગ્ર સુરત શહર ના સભાસદ બહેનો ને જણાવતા અમો  આનંદ અનુભવીએ છીએ કે, આ વિસ્તાર ની એકમાત્ર 3500 સભાસદો ધરાવતી મહિલા ક્રેડિટ સોસાયટી માં સભાસદ થઇ નીચે મુજબ ની યોજનાઓ ના લાભ મેળવો..
          </p>
        </div>
      </div>


      {/* NEWS */}
      <div className="news-section">
        <h2>તાજી માહિતી</h2>

        <div className="news-container">
          {newsList.length === 0 ? (
            <p>કોઈ માહિતી નથી</p>
          ) : (
            newsList.map((news) => (
              <div className="news-card" key={news.id}>
                <span className="news-date">{news.date}</span>
                <h4>{news.title}</h4>
                <p>{news.description}</p>
              </div>
            ))
          )}
        </div>
      </div>


      {/* SERVICES */}
    <div className="scheme-section">
  <h2>સોસાયટી માં શેર સભાપદ બનો અને વિવિધ યોજના ઓ  નો લાભ મેળવો </h2>

  <div className="scheme-container">

    {/* LEFT BOX */}
    <div className="scheme-box">
      <h3>સભાસદ ફી</h3>
      <ul>
        <li>ફરિજયાત બચત               :  3000 /-</li>
        <li>શેર                                    :     500 /-</li>
        <li>વહીવટી ફાળો                   :     300 /-</li>
        <li>બિલ્ડીંગ ફંડ                      :     500 /-</li>
        <li>વીમા યોજના એન્ટ્રી ફ્રી      :  8000 /-</li>
        <li>સ્ટેશનરી ચાર્જ                  :      150 /-</li>
        <li>પ્રવેશ ફી                           :         50/-</li>
        -------------------------------
      </ul>
      <h4>    કુલ       : 12500 /-</h4>
    </div>

<div className="scheme-box">
  <div className="doc-grid">

    {/* LEFT SIDE */}
    <div className="doc-part">
      <h3>જરૂરી દસ્તાવેજ</h3>
      <ul>
        <li>4 ફોટા</li>
        <li>આધાર કાર્ડ</li>
        <li>પાનકાર્ડ</li>
        <li>ચૂંટણી કાર્ડ</li>
        <li>લાઈટ બિલ (ભાડુઆત હોય તો )</li>
        <li>વેરાબીલ રસીદ ફરજીયાત</li>
        <li>બેંક પાસબુક</li>
        <li>સ્કૂલ એલ. સી. / દાખલો</li>
      </ul>
    </div>

    {/* RIGHT SIDE */}
    <div className="doc-part">
      <h3>વારસદાર</h3>
      <ul>
        <li>1 ફોટો</li>
        <li>આધારકાર્ડ</li>
        <li>પાનકાર્ડ</li>
        <li>ચૂંટણીકાર્ડ</li>
        <li>પાસબુક ની ઝેરોક્ષ</li>
      </ul>
    </div>

  </div>
</div>
    {/* RIGHT BOX */}
    <div className="scheme-box">
      <h3>યોજના લાભ</h3>
      <ul>
        <li>નવા સભાસદ બનનાર ને ફ્રી ગિફ્ટ આપવા માં આવશે .</li>
        <li>દર વર્ષે સભાપદ બહેનોના બાળકો ને ઇનામ વિતરણ </li>
        <li>જે વ્યક્તિ ચાર કે તેથી વધુ સભાપદ ગ્રુપ માં લાવે તો તે વ્યક્તિ ને આકર્ષક ગિફ્ટ આપવા માં આવશે.</li>
        <li>દર વર્ષે સભાસદ બહેનોને ફુલસ્કેપ ચોપડા તથા આકર્શક ગિફ્ટ </li>
      </ul>
    </div>

  </div>

  {/* BOTTOM INFO */}
  <div className="scheme-bottom">
    <p>જુના તથા નવા સભાસદે દર વર્ષે તા. 1 એપ્રિલ થી  ફરજીયાત બચત ના રૂ 1000/- ફરજીયાત ભરી પોતાની ફ્રી ગિફ્ટ મેળવી લેવી.</p>
  
  </div>
</div>

      {/* SERVICES */}
      <div className="modern-section">
        <h2>અમારી સેવાઓ</h2>

        <div className="modern-container">
<div 
  className={`modern-card ${activePlan === "bachat" ? "active" : ""}`}
  onClick={() => setActivePlan("bachat")}
>
             <div className="icon">
    <i className="bi bi-piggy-bank"></i>
  </div>
            <h4>બચત યોજના</h4>
            <p>નિયમિત બચત કરીને ભવિષ્ય સુરક્ષિત બનાવો.</p>
          </div>

        <div 
  className={`modern-card ${activePlan === "loan" ? "active" : ""}`}
  onClick={() => setActivePlan("loan")}
>
            <div className="icon">
    <i className="bi bi-shield-check"></i>
  </div>
            <h4>લોન સુવિધા</h4>
            <p>સરળ પ્રક્રિયા સાથે ઝડપી લોન મેળવો.</p>
          </div>

          <div 
  className={`modern-card ${activePlan === "insurance" ? "active" : ""}`}
  onClick={() => setActivePlan("insurance")}
>
           <div className="icon">
    <i className="bi bi-shield-check"></i>
  </div>
            <h4>વીમા યોજના</h4>
            <p>તમારા પરિવાર માટે સુરક્ષિત વીમા લાભ.</p>
          </div>

          <div 
  className={`modern-card ${activePlan === "fd" ? "active" : ""}`}
  onClick={() => setActivePlan("fd")}
>
            <div className="icon">
    <i className="bi bi-graph-up-arrow"></i>
  </div>
            <h4>ફિક્સ ડિપોઝિટ</h4>
            <p>આકર્ષક વ્યાજ સાથે સુરક્ષિત રોકાણ.</p>
          </div>

        </div>
      </div>

      {/* DETAIL SECTION */}
      {activePlan && (
        <div className="plan-detail">

          {activePlan === "bachat" && (
            <>
             

  <div className="plan-grid">

    {/* BOX 1 */}
    <div className="plan-box">
      <h2>બચત યોજના વિગત</h2>
      <p>₹100/- કે ₹100/- ના ગુણાંક માં ગમે તેટલી રકમ માટે 1 વર્ષ ની મુદત માટે ખાતું ખોલાવી શકાય છે.</p>
      <ul>
        <li>₹500 /- ના 12 માસ મુજબ ₹6300/- (સ્ટીલ વાડકી નંગ - 2 )</li>
        <li>₹1000/- ના 12 માસ મુજબ ₹12600/- (સ્ટીલ ગ્લાસ  નંગ - 3 )</li>
        <li>₹2000/- ના માસ મુજબ ₹25200/- (સ્ટીલ ગ્લાસ  નંગ - 6 )</li>
        <li>₹5000/- ના માસ મુજબ ₹63000/- (સ્ટીલ તપેલું  નંગ - 1 )</li>
      </ul>
    </div>

    {/* BOX 2 */}
    <div className="plan-box">
      <h2>અન્ય બચત યોજનાઓ</h2>
      <p>બચત દ્વારા ભવિષ્ય સુરક્ષિત બનાવો.</p>
      <ul>
        <li>સામાન્ય બચત 3.5% વ્યાજ નો દર</li>
        <li>ફરજીયાત બચત 3.5% વ્યાજ નો દર</li>
      </ul>
    </div>

  </div>


              
            </>
          )}

          {activePlan === "loan" && (
            <>
             <h2>પ્રથમ લોન 50000/- મળશે </h2> 
                <ul>
                  <li>લોન લેતી વખતે જે 20% બચત મુકાવતા હતા તેમાં ફેરફાર કરી ને હવે પછી થી 10% બચત જમા કરાવવી એવું નક્કી કરેલ છે.</li>
                  <li>ભાડુઆત સભાપદો માટે ત્રણેય જમીન મિલકત આપીને ક્રમશ: 50,000/- થી 75,000/- (રેગ્યુલર હપ્તા હોય તો ) સુધી મળશે.</li>
                  <li>ટૂંક સમય માટે 55 વર્ષ સુધી ના સભાપદ વીમા સાથે લેવાનું ચાલુ કરેલ છે.</li>
                </ul>
             <div className="plan-grid"> 
             
  <div className="plan-box">
              
         <h2>સોસાયટી ના શેર સભાપદ બની નીચે મુજબ ના લાભ મેળવો </h2>
              <ul>
                <li>સાધન ધિરાણ  : 2,00,000/- (બે લાખ) સુધી </li>
                <li>પ્રોપર્ટી ધિરાણ  : 5,00,000/- (પાંચ લાખ) સુધી </li>
<li>રોકડ ધિરાણ  : 2,00,000/- (બે લાખ) સુધી </li>
<li>એચ. પી. ધિરાણ  : 5,00,000/- (પાંચ લાખ) સુધી </li>
                <li>અનાજ ધિરાણ  : 25,000/- (પચ્ચીસ  હજાર) સુધી </li>
                <li>એફ. ડી. સામે : 90%</li>
              </ul>
    </div>

    {/* BOX 2 */}
    <div className="plan-box">
      <h4>4 ના ગ્રુપ માં સભાપદ બની તુરંત જ ₹50,000/- રોકડ ધિરાણ મેળવો. </h4>
    
    </div>
    </div>

     <h4>લોન નિયમિત ભરનાર ને નિયમો અનુસાર વ્યાજ રિબેટ આપવામાં આવશે. </h4>
           
            
            </>
          )}

          {activePlan === "insurance" && (
            <>
              <h2>વીમા યોજના વિગત</h2>
              <h5>તા. 01/04/2025 થી રૂ 3,00,000/- ની વીમા યોજના સંપૂર્ણ પણે ચાલુ થઇ ગયેલ છે..</h5>
              <h5>વીમો કરાવનાર સભાપદ ને ફ્રી ગિફ્ટ નો લાભ મળશે.</h5>
              <ul>
                <li> તા. : 01/04/2025 થી ધનલક્ષ્મી વીમા સુરક્ષા કવચ યોજના રૂ 3,00,000/- (ત્રણ લાખ )નો સંપૂર્ણં પણે અમલ શરુ થાય ગયેલ છે.</li>
                <li>અગાઉ ની તા : 01/04/2022 થી "શ્રી ધન લક્ષ્મી વીમા સુરક્ષા કવચ" વીમા યોજના રૂ 2,00,000/- (બે લાખ ) વીમાયોજના માં જોડાય શકશે, તેમજ જ્યાં સુધી સભાપદ તરીકે ચાલુ રહેશે ત્યાં સુધી વીમો મળવા પાત્ર છે.</li>
                <li>18 થી 55 વર્ષ સુધી ના સભાપદ વીમા યોજના માં જોડાય શકશે, તેમજ જ્યાં સુધી સભાપદ તરીકે ચાલુ રહેશે ત્યાં સુંભી વીમો મળવા પાત્ર છે.</li>
              </ul>
            </>
          )}

          {activePlan === "fd" && (
            <>
        <div className="plan-grid">    
  <div className="plan-box">
              
        <h2> ફિક્સ ડિપોઝિટ યોજના </h2>
              <ul>
                <li>1 વર્ષ માટે 7%</li>
                <li>2 વર્ષ માટે 8%</li>
                <li>3 વર્ષ માટે 9%</li>
                 <li>9 વર્ષે  બમણા</li>
              </ul>
    </div>
     <div className="plan-box">
         
        <h2>  :: 9 વર્ષે બમણા :: </h2>
              <ul>
                <li>₹5,000 ની F.D. ઉપર સ્ટીલ બાઉલ નંગ -1</li>
                <li>₹10,000 ની F.D. ઉપર સ્ટીલ ડબ્બો નંગ -1</li>
                <li>₹25,000 ની F.D. ઉપર સ્ટીલ કડાઈ નંગ -1</li>
                <li>₹50,000 ની F.D. ઉપર સ્ટીલ તપેલું નંગ -1    </li>
              </ul>
    </div>


    {/* BOX 2 */}
    <div className="plan-box">
      <h5>₹ 25000 /- કે તેથી વધુ રકમ ની ફિક્સ ડિપોઝિટ ત્રણ વર્ષ માટે મુકનાર ને ફ્રી ગિફ્ટ નો લાભ મળશે </h5>
     
    </div>
    </div>
           
            </>
          )}

        </div>
      )}

 <div className="modern-section">
        <h2>અમને કેમ પસંદ કરશો?</h2>

        <div className="modern-container">
<div className="modern-card">
             <div className="icon">
   <i className="bi bi-check-circle"></i>
  </div>
           <h4>પારદર્શક વહીવટ</h4>
      <p>સંપૂર્ણ પારદર્શક અને કાયદેસરની કામગીરી.</p>
          </div>

        <div className="modern-card">
            <div className="icon">
              <i className="bi bi-people"></i>
   
  </div>
           <h4>મહિલા સંચાલિત</h4>
      <p>મહિલાઓ દ્વારા, મહિલાઓ માટે અને મહિલાઓનું સંગઠન.</p>
          </div>

        <div className="modern-card">
           <div className="icon">
      <i className="bi bi-lightning"></i>
  </div>
            <h4>આકર્ષક વ્યાજ દર</h4>
      <p>થાપણો પર વધુ વ્યાજ અને લોન પર વ્યાજબી દર.</p>
          </div>

         <div className="modern-card">
            <div className="icon">
     <i className="bi bi-shield-lock"></i>
  </div>
            <h4>સરળ પ્રક્રિયા</h4>
      <p>લોન અને ખાતા ખોલાવવા માટેની ન્યૂનતમ દસ્તાવેજી પ્રક્રિયા.</p>
          </div>

        </div>
      </div>

      {/* HOLIDAYS */}
      <div className="holiday-section">
        <h2>બેંક રજાઓ</h2>

        <table className="holiday-table">
          <thead>
            <tr>
              <th>ક્રમ</th>
              <th>તારીખ</th>
              <th>રજાનું નામ</th>
            </tr>
          </thead>

          <tbody>
            {holidays.length === 0 ? (
              <tr>
                <td colSpan="3">કોઈ રજા નથી</td>
              </tr>
            ) : (
              holidays.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.name}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </>
  );
}